import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";
import authSlice from "./slices/authSlice";
import preferencesReducer from "./slices/preferencesSlice";
import socketSlice from "./slices/socketSlice";
import userSlice from "./slices/userSlice";
import courseraSlice from "./slices/courseraSlice";
import modalSlice from "./slices/modalSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["preferences"], // Add 'preferences' to persist its state
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  preferences: preferencesReducer,
  coursera: courseraSlice,
  socket: socketSlice,
  modal: modalSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
